<mh-alerts-wrapper>

  <section mhFilterBar>
    <div mhFilterGroup>
      <div>
        <mh-core-lib-datepicker
            [currentDates]="currentDates"
            [currentFilter]="currentFilterDate"
            (datepickerUpdated)="handleDatepickerUpdated($event)">
        </mh-core-lib-datepicker>
      </div>
      <ng-container *ngIf="fidelityPermisions.includes('interchain_collect_result')">
        <mh-core-lib-filter-chain-zone [productId]="productId" (chainChanged)="setChain($event)" [disabled]="!isReady"></mh-core-lib-filter-chain-zone>
        <mh-core-lib-filter-hotels requireSelection [chainFilter]="originalChainFilter" (hotelsChanged)="setHotelsFilter($event)"></mh-core-lib-filter-hotels>
        <mh-core-lib-survey-wrapper *ngIf="chainFilter.length > 0" [productId]="productId" [chain]="chainFilter" [listenCustomerSubscribe]="false"></mh-core-lib-survey-wrapper>
      </ng-container>
    </div>
    <div>
      <mh-filter-date
          [startDate]="startDate"
          [endDate]="endDate"
          [report]="fidelityPermisions.includes('interchain_collect_report') ? 'chainCollectSummary' : null "
          [reportActiveEmail]="true"
          [checkPermissions]="true"
          slug="corporative_collect_properties_report">
      </mh-filter-date>
    </div>
  </section>
  <ng-container *ngIf="!waiting">
    <mh-box-element [title]="('inter-chain.summary.title' | translate )" *ngIf="fidelityPermisions.includes('interchain_collect_result')">
      <mh-chain-collect-summary [currentDates]="currentDates" [chain]="chainFilter" [headerKeys]="headerTable"  (isReady)="dataIsReady($event)" ></mh-chain-collect-summary>
    </mh-box-element>
  </ng-container>

</mh-alerts-wrapper>
